import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { positioning, solutionGroups } from "@/lib/commercial-content";

const Services = () => {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="bg-[#0a0a0a] py-24 md:py-32 relative overflow-hidden"
    >
      <div className="absolute -top-10 -left-10 hidden w-48 h-48 bg-[#ff6b35] opacity-20 rounded-full blur-3xl sm:block" />

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-7 mb-14 sm:mb-16 vc-reveal">
          <div>
            <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-4">
              O que fazemos
            </div>
            <h2 className="font-display text-white text-[2.2rem] min-[380px]:text-[2.55rem] sm:text-7xl uppercase leading-[0.92] max-w-[860px]">
              Web + sistemas <br />
              <span className="text-[#ff6b35]">+ automação.</span>
            </h2>
          </div>
          <p className="text-white/75 max-w-xl text-base sm:text-lg leading-snug">
            {positioning.summary}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-7">
          {solutionGroups.map((solution) => {
            const Icon = solution.icon;
            return (
              <article
                key={solution.n}
                data-testid={`service-card-${Number(solution.n) - 1}`}
                className="vc-reveal bg-[#ff6b35] brutal-card p-6 md:p-8 relative flex min-h-[340px] flex-col"
              >
                <div className="absolute top-4 right-5 font-display text-white text-4xl md:text-5xl opacity-90">
                  {solution.n}
                </div>
                <div className="bg-[#0a0a0a] w-14 h-14 md:w-16 md:h-16 flex items-center justify-center brutal-border mb-7">
                  <Icon size={27} className="text-[#ff6b35]" />
                </div>
                <h3 className="font-display text-[#0a0a0a] text-[1.65rem] min-[380px]:text-3xl md:text-[2rem] uppercase mb-3 leading-[0.95]">
                  {solution.title}
                </h3>
                <p className="text-white text-base md:text-lg leading-snug max-w-md">
                  {solution.outcome || solution.forWho}
                </p>
                <Link
                  to="/solucoes"
                  className="mt-auto pt-7 inline-flex items-center gap-2 font-mono uppercase text-[0.72rem] tracking-widest text-[#0a0a0a] hover:text-white transition-colors"
                >
                  <span className="w-8 h-[3px] bg-current" />
                  <span>Ver soluções</span>
                  <ArrowRight size={15} className="shrink-0" />
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
